import VectorLayer from "ol/layer/Vector";
import { extentTucuman, extentGsmt } from "../../utils/extents";
import ImageLayer from "ol/layer/Image";
import { updateChildCount } from "..";

export const creacionDivBotones = (contenedorCapa, layer, layerName, view) => {
  //div botones de la capa (de cada capa)
  const botones = document.createElement("div");
  botones.className = "capas-activas-panel-botones";

  //boton de informacion
  const botonInformacion = document.createElement("button");
  botonInformacion.className = "btn btn-informacion";
  botonInformacion.textContent = "";

  const fetchXMLCapabilities = async () => {
    try {
      const url = `${
        import.meta.env.VITE_GEOSERVER_URL
      }/censo2022/wms?service=wms&version=1.3.0&request=GetCapabilities&layers=nbi1_por_gobierno_local_censo_2022`;
      const response = await fetch(url);
      const text = await response.text();

      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(text, "application/xml");

      const layers = xmlDoc.getElementsByTagName("Layer");

      for (let layer1 of layers) {
        const name =
          layer1.getElementsByTagName("Name")[0]?.textContent.trim() ||
          "No Name";
        if (name == layer.getSource().getParams().LAYERS) {
          const abstract =
            layer1.getElementsByTagName("Abstract")[0]?.textContent;
          return abstract;
        }
      }
      return "No abstract";
    } catch (error) {
      console.error("Error fetching or parsing XML:", error);
      return [];
    }
  };

  botonInformacion.addEventListener("click", async () => {
    const c = await fetchXMLCapabilities();

    // Create the dialog and other elements
    const dialog = document.createElement("dialog");

    const div = document.createElement("div");
    const layerText = document.createElement("h3");
    layerText.textContent = layerName;

    const lineBreak = document.createElement("br");

    const abstractText = document.createElement("span");
    abstractText.textContent = c;

    // Append the elements to the dialog
    div.appendChild(layerText);
    div.appendChild(lineBreak);
    div.appendChild(abstractText);
    dialog.appendChild(div);

    // Add dialog to the body (or a specific container)
    document.body.appendChild(dialog);

    // Show the modal dialog
    dialog.showModal();

    // Optionally add close button functionality
    const botonCerrar = document.createElement("button");
    botonCerrar.classList.add("close-btn");
    botonCerrar.innerText = "X";
    div.appendChild(botonCerrar);

    botonCerrar.addEventListener("click", () => {
      dialog.close(); // Close the dialog
      dialog.remove(); // Optionally remove the dialog from the DOM
    });
  });

  botones.appendChild(botonInformacion);

  //boton eliminar
  const botonEliminar = document.createElement("button");
  botonEliminar.classList.add("btn", "btn-eliminar-capa");

  botonEliminar.addEventListener("click", () => {
    //map.removeLayer(layer); // Elimina la capa del mapa
    //console.log(layer)
    layer.setVisible(false);

    const label = Array.from(document.querySelectorAll("label")).find(
      (l) => l.innerText === layerName
    );
    //label obenter el input y descheck
    if (label) {
      const checkboxId = label.getAttribute("for");
      const checkbox = document.getElementById(checkboxId);
      if (checkbox && checkbox.type === "checkbox") {
        checkbox.checked = false;
      }
    }

    if (layer instanceof VectorLayer) {
      contenedorCapa.remove();
      //update child count?[]
      updateChildCount();
    }
  });

  botones.appendChild(botonEliminar);

  //boton descarga
  if (layer instanceof ImageLayer) {
    const layerGeoserver = layer.getSource().getParams().LAYERS;
    const grupo = layer.getSource().getParams().grupo;

    if (grupo != null && grupo != "otros") {
      let botonDescargarCapa = document.createElement("button");

      botonDescargarCapa.innerText = "";

      botonDescargarCapa.addEventListener("click", () => {
        //console.log(grupo,layerGeoserver)
        const urlwfs = `https://geoserver.estadistica.tucuman.gob.ar/geoserver/${grupo}/ows?service=WFS&version=1.3.0&request=GetFeature&typeName=${grupo}%3A${layerGeoserver}&srsName=EPSG:5345&outputFormat=SHAPE-ZIP`;
        const link = document.createElement("a");
        link.href = urlwfs;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
      botones.appendChild(botonDescargarCapa);
      botonDescargarCapa.classList.add("btn", "btn-descargar-capa");
    }
  }

  //boton zoom
  const botonZoom = document.createElement("button");
  botonZoom.classList.add("btn", "btn-zoom-capa");
  botones.appendChild(botonZoom);

  botonZoom.addEventListener("click", () => {
    let extent = [];
    if (layerName.includes("SMT")) {
      extent = extentGsmt;
    } else {
      extent = extentTucuman;
      view.fit(extent);
    }
    view.fit(extent, { padding: [20, 20, 20, 20] });
  });

  contenedorCapa.appendChild(botones);
};
